module.exports = __webpack_public_path__ + "img/nomessage.42d2ac5b.png";